/*global myModal, notification, inputDirectionChange */

var account = {
    init: function() {
        account.action();
        account.validate();
    },
    action: function() {

        $('.edit-account').on('click', function(e) {
            e.preventDefault();
            const that = $(this);
            const view = that.data('view');
            $('.account-item-view.' + view).addClass('hidden');
            $('.account-item-edit.' + view).removeClass('hidden');
        });

        $('.cancel-edit-account').on('click', function(e) {
            e.preventDefault();
            const that = $(this);
            const view = that.data('view');
            $('.account-item-edit.' + view).addClass('hidden');
            $('.account-item-view.' + view).removeClass('hidden');
        });

        $('#residence').chosen({
            inherit_select_classes: true,
            no_results_text: _d.t.chosen_no_results_text,
            width: '100%'
        }).on('blur', function() {
            $(this).trigger('chosen:updated');
        });

        inputDirectionChange.onChangeAction($('.account-item-edit.residence .booking-form-row-cell input'));

    },
    validate: function() {
        $.validator.addMethod('onlyLatin', function(val) {
            const latinMatch = /^[a-zA-Z\.\'\-\s]+$/;
            return latinMatch.test(val.trim()) !== false;
        });

        $('.account-form').each(function() {  // attach to all form elements on page
            $(this).validate({
                ignore: null,
                errorClass: 'error ws-normal',
                errorElement: 'div',
                focusInvalid: false,
                groups: {
                    dob: 'driver_birth_dt_day driver_birth_dt_month driver_birth_dt_year'
                },
                errorPlacement: function(error, el) {
                    $(el).parents('.booking-form-row-cell').find('.error-message').addClass('show').append(error);
                },
                highlight: function(el, ec) {
                    let handler = $(el);
                    let isSelect = (handler[0].localName === 'select');

                    if (isSelect) {
                        handler.parent().removeClass('success').addClass('red');
                    } else {
                        handler.removeClass('success').addClass(ec);
                    }
                },
                showErrors: function() {
                    this.defaultShowErrors();
                },
                unhighlight: function(el, ec) {
                    var handler = $(el),
                        isSelect = (handler[0].localName === 'select');

                    if (isSelect) {
                        handler.parent().removeClass('red').addClass('success');
                    } else {
                        if (handler.val().length > 0) {
                            handler.addClass('success');
                        }
                        handler.removeClass(ec);
                    }
                },
                submitHandler: function(form) {
                    $(form).find('.error-message').html('');
                    account.update($(form));
                }
            });
        });
    },
    update: function(form) {
        let btn = form.find('.account-form-btn');

        $('.account-form-btn').prop('disabled', true);
        btn.prop('disabled', true).addClass('loading');


        $.ajax({
            url: _d.url.account.update,
            type: 'POST',
            data: form.serialize(),
            success: function(response) {
                $('.account-form-btn').prop('disabled', false);
                btn.prop('disabled', false).removeClass('loading');
                form.find('.cancel-edit-account').trigger('click');
                $('#' + response.data.id).html(response.data.text);
                setTimeout(() => {
                    notification.toast(_d.t.changesSaved);
                }, 1000);
            },
            error: function(jqXHR) {
                $('.account-form-btn').prop('disabled', false);
                btn.prop('disabled', false).removeClass('loading');

                $.each(jqXHR.responseJSON.errors.message, function(element, message) {
                    var options = {msg: message, isSelect: $('#' + element).hasClass('select-field')};
                    account.addError(element, options);
                });
            }
        });
    },
    addError: function(element, options) {
        const elementHandler = $('#' + element);
        const errorHandler = $('<div>').attr('id', element + '_error').attr('class', 'error').append(options.msg);

        elementHandler.parents('.booking-form-row-cell').addClass('error-field').find('.error-message').append(errorHandler);

        elementHandler.parents('.booking-form-row-cell').find('.error-message').addClass('show');

        if (elementHandler.get(0).type === 'select-one') {
            elementHandler.parent().removeClass('success').addClass('red');
        } else {
            elementHandler.removeClass('success').addClass('error ws-normal');
        }
    }
};
